/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { calendarEventConversationSchema } from './calendar-event-conversation-schema';
import { calendarSchema } from './calendar-schema';
import { candidateSchema } from './candidate-schema';
import { contactSchema } from './contact-schema';
import { userSchema } from './user-schema';
import { AttendeeResponseType } from "../enums";

export const calendarEventSchema: z.AnyZodObject = z.object({
  adhocEmail: z.string().nullish(),
  adhocFirstName: z.string().nullish(),
  adhocLastName: z.string().nullish(),
  atRiskAlertSentAt: z.string().datetime().nullish(),
  attendeeResponse: z.nativeEnum(AttendeeResponseType).nullish(),
  busy: z.boolean(),
  calendar: z.lazy(() => calendarSchema).nullish(),
  calendarId: z.string().uuid().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  contact: z.lazy(() => contactSchema).nullish(),
  contactId: z.string().uuid().nullish(),
  conversation: z.lazy(() => calendarEventConversationSchema).nullish(),
  conversationId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  createdBy: z.string().uuid().nullish(),
  createdByUser: z.lazy(() => userSchema).nullish(),
  endTime: z.string().datetime().nullish(),
  id: z.string().uuid(),
  officeEventId: z.string().nullish(),
  refId: z.string().nullish(),
  startTime: z.string().datetime().nullish(),
  title: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  updatedBy: z.string().uuid().nullish(),
  updatedByUser: z.lazy(() => userSchema).nullish(),
  zoomId: z.string().nullish(),
  zoomLink: z.string().nullish(),
});

export type CalendarEvent = z.infer<typeof calendarEventSchema>;
